import { applyNoTranslatePolicy } from "@/core/utils/func/apply-no-translate";
import { useEffect, type PropsWithChildren } from "react";

/**
 * Enveloppe racine : désactive la traduction auto du navigateur sur toute l'app.
 * Ne touche pas à `lang` (géré par i18n).
 *
 * Simplifié vs $WA : pas de react-helmet-async — applyNoTranslatePolicy pose
 * les mêmes marqueurs (html/body/#root translate="no" + meta google notranslate)
 * de façon impérative.
 */
export function NoTranslateShell({ children }: PropsWithChildren) {
  useEffect(() => {
    applyNoTranslatePolicy();
  }, []);

  return (
    <div className="contents notranslate" translate="no">
      {children}
    </div>
  );
}
